// V97 13/10/2026 : points sous le slider « Complétez votre coffret » du panier (le panier se redessine, d'où l'observateur).
(function(){
  function setup(root){
    root.querySelectorAll('.ma3-cart-suggestions').forEach(box=>{
      const track=box.querySelector('.ma7-accessory-track'),dots=box.querySelector('.ma97-dots');
      if(!track||!dots||dots.dataset.ready)return;dots.dataset.ready='1';
      const items=[...track.children];if(items.length<2){dots.hidden=true;return;}
      const n=Math.min(items.length,4);dots.innerHTML=Array.from({length:n},(_,i)=>'<span'+(i===0?' class="is-on"':'')+'></span>').join('');
      const step=()=>items[1]?items[1].offsetLeft-items[0].offsetLeft:track.clientWidth;
      track.addEventListener('scroll',()=>{const max=Math.max(1,track.scrollWidth-track.clientWidth),i=Math.round(Math.min(1,track.scrollLeft/max)*(n-1));[...dots.children].forEach((d,j)=>d.classList.toggle('is-on',j===i));},{passive:true});
    });
  }
  const run=()=>setup(document);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  new MutationObserver(run).observe(document.documentElement,{childList:true,subtree:true});
})();
